import { Badge, Box, Flex, Text } from '@chakra-ui/react';

type MetaTone = 'muted' | 'success' | 'warning';

interface CreateOfferSectionProps {
  children: React.ReactNode;
  description: string;
  meta?: string;
  metaTone?: MetaTone;
  title: string;
}

export function CreateOfferSection({
  children,
  description,
  meta,
  metaTone = 'muted',
  title,
}: CreateOfferSectionProps) {
  return (
    <Flex direction="column" gap={3}>
      <Flex align="flex-start" gap={3} justify="space-between">
        <Box>
          <Text fontFamily="barlow" fontSize="15px" fontWeight="semibold">
            {title}
          </Text>
          <Text color="offerDrawer.mutedText" fontSize="11px" mt={0.5}>
            {description}
          </Text>
        </Box>
        {meta && (
          <Badge
            bg={getMetaBackground(metaTone)}
            borderRadius={0}
            color={getMetaColor(metaTone)}
            flexShrink={0}
            fontSize="9px"
          >
            {meta}
          </Badge>
        )}
      </Flex>
      {children}
    </Flex>
  );
}

function getMetaBackground(tone: MetaTone) {
  if (tone === 'success') return 'offerDrawer.successBackground';
  if (tone === 'warning') return 'offerDrawer.warningBackground';
  return 'offerDrawer.raisedSurface';
}

function getMetaColor(tone: MetaTone) {
  if (tone === 'success') return 'offerDrawer.success';
  if (tone === 'warning') return 'offerDrawer.warningText';
  return 'offerDrawer.mutedText';
}
